import React, { Component } from "react";
import * as _ from "lodash-es";
import Typeahead from "../Typeahead/Typeahead";

type Props = {
    selectedItem?: any;
    selectedItemValueProp: string;
    selectedItemValueSubProp?: string;
    selectedItemTitleProp: string;
    clearTypeaheadCallback?: any;
    clearTypeahead?: boolean;
    typeaheadItems?: any[];
    titleProp?: string;
    subTitleProp?: string;
    valueProp?: string;
    maxResults?: number;
    confirmAdd?: boolean;
    isSelectableFn: any;
    selectedItemFn: any;
    notFoundText?: string;
    disabled?: boolean;
};

type State = {
    selectedItem?: any;
    staticValue?: any;
    notFoundText?: string;
};

export class OwStaticTypeahead extends Component<Props, State> {
    static defaultProps = {
        maxResults: 10,
        title: "name",
    };

    constructor(props: any) {
        super(props);

        const state = {
            selectedItem: this.props.selectedItem,
            staticValue: null,
        };

        if (this.props.selectedItem && this.props.selectedItemValueProp) {
            if (!this.props.selectedItemValueSubProp) {
                state.staticValue = this.props.selectedItem[this.props.selectedItemValueProp];
            } else {
                state.staticValue = this.props.selectedItem[this.props.selectedItemValueProp][this.props.selectedItemValueSubProp];
            }
        }

        this.state = state;
    }

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        this.setState({
            [name]: value,
        });
    };

    handleTypeaheadChange = (value: string) => {
        this.setState({
            staticValue: value,
        });
    };

    selectedItemFn = (item: any) => {
        const valueProp = _.get(this.props, "valueProp");
        let selectedItem;

        if (!_.isNil(valueProp)) {
            selectedItem = _.get(item, `${valueProp}`, "");
        } else {
            selectedItem = item;
        }

        this.setState(
            {
                selectedItem,
                staticValue: "",
            },
            () => {
                this.props.selectedItemFn(item);
            }
        );
    };

    getTypeaheadItemsFormatted = (_typeaheadItems: any[]): any => {
        if (!_.isNil(_typeaheadItems)) {
            let typeaheadItemsFormatted: any = [];

            if (_typeaheadItems.length && this.state.staticValue) {
                let typeaheadItems = _typeaheadItems;

                const maxResults = this.props.maxResults!;

                typeaheadItems = _.slice(typeaheadItems, 0, maxResults - 1);

                if (_typeaheadItems.length > maxResults) {
                    typeaheadItems.push({
                        name: `More than ${maxResults} results. Please refine.`,
                        description: "",
                    });
                }

                // console.log("typeaheadItems", typeaheadItems);

                typeaheadItemsFormatted = typeaheadItems.map((item: any, index: number) => {
                    // let isSelectable = this.state.isSelectableFn(item);

                    const { titleProp, subTitleProp } = this.props;

                    return (
                        <div
                            role={"option"}
                            className={"typeahead-item d-flex w-100 p-2 pointer "}
                            key={index}
                            onClick={(e) => {
                                this.selectedItemFn(item);
                            }}>
                            <span className="me-auto">
                                <div>{item[titleProp!]}</div>
                                <small className="text-muted">{item[subTitleProp!]}</small>
                            </span>
                        </div>
                    );
                });
            } else {
                typeaheadItemsFormatted = <div role={"option"} className="typeahead-item d-flex w-100 p-2">{this.state.notFoundText}</div>;
            }

            // console.log(typeaheadItemsFormatted);

            return typeaheadItemsFormatted;
        }
    };

    getMatchingTypeaheadItems = (): any[] => {
        const matchingItems = _.filter(this.props.typeaheadItems, (items) => {
            let value = _.get(items, `${this.props.titleProp}`);

            let staticValue = this.state.staticValue;

            // console.log("value", value, "staticValue", staticValue);

            if (!_.isNil(staticValue) && _.isString(staticValue)) {
                staticValue = staticValue.toLowerCase();
            }

            if (!_.isNil(value) && _.isString(value)) {
                value = value.toLowerCase();
            }

            if (!_.isNil(value) && _.isString(value)) {
                return value.includes(staticValue);
            } else {
                return false;
            }
        });

        // console.log("matchingItems", matchingItems);

        return matchingItems;
    };

    render() {
        // const titleProp = _.get(this.props, "selectedItemTitleProp");
        const valueProp = _.get(this.props, "selectedItemValueProp");

        let selectedItem: any;

        if (!_.isNil(valueProp)) {
            selectedItem = _.get(this.state.selectedItem, `${valueProp}`, "");
        } else {
            selectedItem = _.get(this.state, "selectedItem", null);
        }

        let inputValue = "";

        _.each(this.props.typeaheadItems, (item) => {
            const itemValue = _.get(item, `${this.props.valueProp}`);

            if (itemValue === selectedItem) {
                inputValue = _.get(item, `${this.props.titleProp}`);
            }
        });

        // console.log("inputValue", inputValue);
        // console.log("this.props.selectedItem", this.props.selectedItem);

        const matchingTypeaheadItems = this.getMatchingTypeaheadItems();

        // let typeaheadItemsFormatted = this.getTypeaheadItemsFormatted(matchingTypeaheadItems);

        // let hideTypeahead = true;
        //
        // if (typeaheadItemsFormatted.length) {
        //     hideTypeahead = false;
        // }

        if (this.state.staticValue) {
            // console.log("staticValue", this.state.staticValue, matchingTypeaheadItems);
            // console.log("OwStaticTypeahead Selected Item: ", this.props.selectedItem);
        }

        return (
            <div className="OwStaticTypeahead position-relative">
                <Typeahead
                    isSelectableFn={this.props.isSelectableFn}
                    typeaheadApiFn={this.handleTypeaheadChange}
                    selectedItem={this.props.selectedItem}
                    selectedItemTitleProp={this.props.selectedItemTitleProp}
                    typeaheadItems={matchingTypeaheadItems}
                    titleProp={this.props.titleProp}
                    className={""}
                    disabled={false}
                    clearTypeahead={this.props.clearTypeahead}
                    clearTypeaheadCallback={this.props.clearTypeaheadCallback}
                    maxResults={5}
                    selectedItemFn={this.props.selectedItemFn}
                    placeholder={"search"}
                />
            </div>
        );
    }
}

export default OwStaticTypeahead;
